import * as React from "react";
import styled from "styled-components";
import Textfield from "../Merchant/Textfield";
import Box from "../Box";
import Selectfield from "../Merchant/Selectfield";
import MultiDateSelector from "../MultiDateSelector";
import Datefield from "../Events/Datefield";
import DropdownCheckbox from "./DropdownCheckbox";
import Button from "../Button";
import { Colors } from "../../config/Constants";

interface Props {
  restrictProductDiscount: any;
  parkProducts: any;
  onChange: any;
  onUpdateRestrictedProduct: any;
}

const RestrictProductDiscount: React.FC<Props> = ({
  onChange,
  onUpdateRestrictedProduct,
  restrictProductDiscount,
  parkProducts,
}) => {
  const canAddMoreProducts = () => {
    const selected = restrictProductDiscount
      .map((r: any) => r.product)
      .filter((p: any) => p !== "");

    const uniqueSelected = Array.from(new Set(selected));

    return uniqueSelected.length < parkProducts.length;
  };
  return (
    <>
      <StyledPageHeader>Restrict Product Discount</StyledPageHeader>
      <Box>
        <LabelRow>
          <FieldWrapper>
            <div style={{ textAlign: "left" }}>
              <Label>Products</Label>
            </div>
          </FieldWrapper>
          <FieldWrapper>
            <div style={{ textAlign: "left" }}>
              <Label>Excluded Dates</Label>
            </div>
          </FieldWrapper>
          <FieldWrapper />
        </LabelRow>
        {restrictProductDiscount.map((rpd: any, idx: any) => (
          <FormRow>
            <FieldWrapper>
              <Selectfield
                label=""
                data={parkProducts.filter((product: any) => {
                  return !restrictProductDiscount.some(
                    (r: any, i: any) =>
                      i !== idx &&
                      r.product !== "" &&
                      r.product === product.value
                  );
                })}
                name="product"
                value={rpd.product}
                onChange={(e) => onChange(e, idx)}
              />
            </FieldWrapper>
            <FieldWrapper>
              <MultiDateSelector
                fullWidth
                label=""
                placeholder="Select Dates"
                onDateSelect={(e) => onChange(e, idx)}
                required={false}
                helperText={""}
                name="excludeDate"
                value={rpd.excludeDate.map((dates: any) =>
                  dates.replaceAll("-", "/")
                )}
              />
            </FieldWrapper>
            <FieldWrapper>
              <div style={{ display: "flex", alignItems: "center" }}>
                {
                  <Button
                    label="Remove"
                    onClick={() => onUpdateRestrictedProduct(idx, "remove")}
                    color={Colors.white}
                    width="100px"
                    outlineColor={Colors.red}
                    fontColor={Colors.red}
                  />
                }
                <div style={{ width: "1rem" }} />
                {idx < parkProducts.length - 2 &&
                  idx === restrictProductDiscount.length - 1 && (
                    <Button
                      label="Add More"
                      onClick={() => onUpdateRestrictedProduct(idx, "add")}
                      color={Colors.red}
                      width="100px"
                      outlineColor="transparent"
                      fontColor={Colors.white}
                      disabled={
                        rpd.product === "" || rpd.excludeDate?.length === 0
                      }
                    />
                  )}
              </div>
            </FieldWrapper>
          </FormRow>
        ))}
        <Note>
          <strong style={{ fontWeight: 900 }}>
            Note: Entries are retained only if they have a selected product and
            at least one excluded date. All past dates are automatically
            removed.
          </strong>
        </Note>
      </Box>
    </>
  );
};

const Note = styled.div`
  border-radius: 4px;
  color: ${Colors.blackOpacity};
  font-size: 12px;
  margin-top: 24px;
  font-style: italic;
  strong {
    // font-style: italic;
    font-weight: 700; // or 900 if your font supports it
    color: ${Colors.black}; // Optional: make it stand out
  }
`;

const StyledPageHeader = styled.div`
  font-size: 1.25rem;
  font-family: "Poppins-Medium";
  line-height: 1.75rem;
  margin-top: 1.5rem;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const StyledHeader = styled.div`
  font-size: 1rem;
  font-family: "Poppins-Medium";
  //   line-height: 1.75rem;
  margin-bottom: 0.5rem;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const FieldWrapper = styled.div`
  flex: 1;
  @media only screen and (max-width: 768px) {
    margin-top: 0.5rem;
  }
`;

const FormGrid = styled.div`
  display: grid;
  gap: 1.5rem;
  grid-template-columns: 1fr 1fr 1fr;
  @media only screen and (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
  @media only screen and (max-width: 468px) {
    grid-template-columns: 1fr;
  }
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  @media only screen and (max-width: 768px) {
    gap: 0.5rem;
  }
`;

const FormRow = styled.div`
  display: flex;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const LabelRow = styled.div`
  display: flex;
  gap: 1.5rem;
  margin-bottom: 0.5rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

interface GapProps {
  height: string;
  height2?: string;
  width?: string;
}

export const Gap = styled.div<GapProps>`
  height: ${(GapProps) => GapProps.height};
  @media only screen and (max-width: 768px) {
    height: ${(GapProps) =>
      GapProps.height2 ? GapProps.height2 : GapProps.height};
    width: ${(GapProps) => GapProps.width};
  }
`;

const Label = styled.label`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 350;
  font-size: 13px;
  line-height: 16px;
  color: ${Colors.electricBlue};
  margin-bottom: 0.5rem;
  > span {
    color: ${Colors.red};
    margin-left: 2px;
  }
`;

export default RestrictProductDiscount;
